import Cookies, { CookieAttributes } from 'js-cookie';

const LOCALHOST = 'localhost';

function getCookieDomain() {
  let domain = LOCALHOST;
  const hostname = window.location.hostname;

  if (hostname !== LOCALHOST) {
    domain = `.${hostname}`;
  }

  return domain;
}

function getCookie(key: string) {
  try {
    return Cookies.get(key) ?? '';
  } catch (e) {
    window.sc3WorkbenchLogger.error(`Error occurred while getting cookie with key: ${key}.`, e);
  }

  return '';
}

function setCookie(key: string, value: string, expirationDate?: Date | number) {
  const cookieOptions: CookieAttributes = {
    domain: getCookieDomain(),
    path: '/'
  };

  if (expirationDate) {
    cookieOptions.expires = expirationDate;
  }

  try {
    Cookies.set(key, value, cookieOptions);

    window.sc3WorkbenchLogger.info(`Successfully set cookie with key: ${key} to value: ${value}.`);
  } catch (e) {
    window.sc3WorkbenchLogger.error(`Error occurred while setting cookie with key: ${key} to value ${value}.`, e);
  }
}

function removeCookie(key: string) {
  try {
    Cookies.remove(key, { domain: getCookieDomain(), path: '/' });

    window.sc3WorkbenchLogger.info(`Successfully removed cookie with key: ${key}.`);
  } catch (e) {
    window.sc3WorkbenchLogger.error(`Error occurred while removing cookie with key: ${key}.`, e);
  }
}

export function useCookies() {
  return {
    getCookie,
    setCookie,
    removeCookie
  };
}
